import React from "react"
import { List } from "@cd2/components"
import { LabelInfo } from "../Components/LabelInfo"
import { IRecord } from "../types/schema"
import { HoverResourceLoader } from "./HoverResourceLoader"

type ISupplier = IRecord<"suppliers", "name">

interface IProps {
  id?: string
  initialData?: ISupplier
  renderInlineLink?: "block" | "inline"
}

export function HoverSupplierLoader({ id, initialData, renderInlineLink }: IProps) {
  const skeem = window.skeem

  async function loadData() {
    const supplier = await skeem.fetchOne<ISupplier>({
      suppliers: {
        attributes: ["name"],
        filter: { matches: { id } },
      },
    })
    return supplier
  }

  if (!id) {
    return <span>-</span>
  }

  return (
    <HoverResourceLoader
      reloadKey={id}
      loadData={loadData}
      initialData={initialData}
      resourceName="Supplier"
      renderHoverContentTitle={record => record.name}
      renderInlineLink={renderInlineLink}
      renderHoverContent={record => (
        <div>
          <List>
            <LabelInfo labelWidth={80} label="Name" value={record.name} inline />
          </List>
        </div>
      )}
      renderTarget={record => <span>{record.name}</span>}
    />
  )
}
